const skillData = [
  // {
  //   name: "REACT JS",
  //   imgurl: require("../Assets/react.png"),
  // },
  // {
  //   name: "Redux",
  //   imgurl: require("../Assets/redux.png"),
  // },
  // {
  //   name: "SASS",
  //   imgurl: require("../Assets/sass.png"),
  // },
  // {
  //   name: "Material UI",
  //   imgurl: require("../Assets/mui.png"),
  // },
  // {
  //   name: "Jest",
  //   imgurl: require("../Assets/jest.png"),
  // },
  // {
  //   name: "Firebase",
  //   imgurl: require("../Assets/firebase.png"),
  // },
  {
    name: "",
    imgurl: require("../Assets/asp.png"),
  },
  {
    name: "",
    imgurl: require("../Assets/AspNetCore.png"),
  },
  {
    name: "",
    imgurl: require("../Assets/mysql.png"),
  },
];

const ExpData = [
  {
    position: "Software Developer",
    company: "NeST Digital",
    Duration: "Aug 2022-Present",
    companyUrl: "https://www.nestdigital.com",
    companyLogo: require("../Assets/nest.png"),
    ExpDesc:
      "I have contributed to building and maintaining full-stack web applications for prominent banks in the UAE, focusing on enhancing digital banking solutions. My work involved developing new web pages, implementing Windows and SFTP services, and building robust REST APIs,Database management. Additionally, I played a key role in unit testing and optimizing the Wage Protection System (WPS) to ensure security, performance, and reliability in critical banking operations.",
  },
  // {
  //   position: "Quaity Analyst-Intern",
  //   company: "Playspots",
  //   Duration: "2020 June-2021 July",
  //   companyUrl: "https://networkacademy.org/",
  //   companyLogo: require("../Assets/nwa.jpg"),
  //   ExpDesc:
  //     "I contributed to the quality assurance of mobile and web applications by performing manual testing and creating detailed test cases. I collaborated with development teams to identify bugs, improve functionality, and suggest new features that enhanced user engagement and attracted more users. My efforts helped improve the overall performance and user experience of the applications.",
  // },
];

const EduData = [
  {
    schoolIcon: require("../Assets/college.png"),
    course: "Master Of Computer Applications",
    Duration: "2020-2022",
    institute: "Nirmala College, Muvattupuzha",
    university: "Mahatma Gandhi University, Kottayam",
    marks: "8.6 CGPA",
  },
  {
    schoolIcon: require("../Assets/college.png"),
    course: "Bachelor Of Computer Applications",
    Duration: "2016-2019",
    institute: "Mar Baselios College, Adimali",
    university: "Mahatma Gandhi University, Kottayam",
    marks: "7.1 CGPA",
  },

  {
    schoolIcon: require("../Assets/school.png"),
    course: "Higher Secondary School",
    Duration: "2014-2016",
    institute: "GHSS Rajakumary, Idukki",
    university: "Kerala State Board",
    marks: "82%",
  },
];
const CertificateData = [
  {
    name: "introduction to cybersecurity",
    issuer: "Cisco",
    date: "Feb 2024-Feb 2026",
    url: "",
    imageUrl: ""
  },
  {
    name: "Generic online training in CYBER SECURITY",
    issuer: "Ministry of Electronics and Information Technology",
    date: "Nov 2022",
    url: "https://drive.google.com/file/d/1P_NuJi0c6kw-uCnu9H--SaztwdXJ6gW9/view?usp=sharing",
    imageUrl: require("../Assets/ministry.png"),
  },
  {
    name: "Accenture developer Program",
    issuer: "Accenture",
    date: "Nov 2021",
    url: "https://drive.google.com/file/d/1NKs5BcL0m92apoMKdTl3QnpyK-Waz43S/view?usp=sharing",
    imageUrl: "",
  },
];

const ProfileData=[
  {
    name:"Github",
    url:"https://github.com/Basil-C-Eldhose",
    imageUrl: require("../Assets/github.jpg")
  },
  {
    name:"Linkedin",
    url:"https://www.linkedin.com/in/basil-c-eldhose-44b766216/",
    imageUrl: require("../Assets/linkedin.png")
  }]
export { skillData, ExpData, EduData, CertificateData,ProfileData };
